// Read stored waypoints without changing the booking or inferring an address.
export function readRideStops(raw) {
  if (raw == null || raw === '') return { stops: [], unreadable: false };
  let entries = raw;
  if (typeof raw === 'string') {
    try { entries = JSON.parse(raw); } catch { return { stops: [], unreadable: true }; }
  }
  if (!Array.isArray(entries)) return { stops: [], unreadable: true };
  const coordinate = (value, limit) => {
    if (typeof value !== 'number' && typeof value !== 'string') return null;
    if (typeof value === 'string' && !value.trim()) return null;
    const number = Number(value);
    return Number.isFinite(number) && Math.abs(number) <= limit ? number : null;
  };
  return {
    unreadable: false,
    stops: entries.map((entry, index) => {
      const lat = coordinate(Array.isArray(entry) ? entry[0] : entry?.lat, 90);
      const lng = coordinate(Array.isArray(entry) ? entry[1] : entry?.lng, 180);
      const position = lat == null || lng == null ? null : [lat, lng];
      const storedLabel = [entry?.address, entry?.name, entry?.label]
        .find((value) => typeof value === 'string' && value.trim());
      return {
        number: index + 1,
        position,
        label: storedLabel?.trim() || (position
          ? `Koordinaten: ${lat.toFixed(5)}, ${lng.toFixed(5)}`
          : 'Position nicht verfügbar'),
      };
    }),
  };
}
